import React, { useState } from 'react';
import { MultiSelect } from '../ui/MultiSelect';
export function InterestTab() {
  const [selectedInterest, setSelectedInterest] = useState<string[]>([]);
  return <div className="space-y-6 max-w-4xl animate-in fade-in slide-in-from-bottom-4 duration-500" data-id="element-700">
      <MultiSelect label="Interest/Markup Types (Optional)" value={selectedInterest} onChange={setSelectedInterest} placeholder="Select one or multiple interest/markup types..." options={[{
      value: 'fixed',
      label: 'Fixed Rate'
    }, {
      value: 'variable_libor',
      label: 'Variable Rate (LIBOR)'
    }, {
      value: 'reducing',
      label: 'Reducing Balance'
    }, {
      value: 'flat',
      label: 'Flat Rate'
    }, {
      value: 'compound',
      label: 'Compound Interest'
    }, {
      value: 'simple',
      label: 'Simple Interest'
    }, {
      value: 'hybrid',
      label: 'Hybrid (Fixed + Variable)'
    }]} data-id="element-701" />

      <div className="bg-orange-50 p-4 rounded-md border border-orange-100" data-id="element-702">
        <p className="text-sm text-orange-600" data-id="element-703">
          Select the interest or markup calculation methods applicable to this
          loan product. Multiple types can be configured.
        </p>
      </div>
    </div>;
}